export default {
      id: "Icon--track-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--track",
      toString: function () {
        return this.url;
      }
    }